import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "testimonial-section" }
const _hoisted_2 = {
  key: 0,
  class: "testimonial-state"
}
const _hoisted_3 = {
  key: 1,
  class: "testimonial-state"
}
const _hoisted_4 = {
  key: 2,
  class: "testimonial-state"
}
const _hoisted_5 = { class: "testimonial-content desktop-testimonial" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  class: "testimonial-card",
  "data-aos": "fade-up",
  "data-aos-delay": "150",
  "data-aos-duration": "500"
}
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "test-description" }
const _hoisted_11 = { class: "testimonial-info" }
const _hoisted_12 = { class: "testimonial-name" }
const _hoisted_13 = { class: "testimonial-rates" }
const _hoisted_14 = { class: "testimonial-mobile" }
const _hoisted_15 = { class: "swiper testimonial-wrapper" }
const _hoisted_16 = { class: "swiper-wrapper" }
const _hoisted_17 = {
  class: "testimonial-card",
  "data-aos": "fade-up",
  "data-aos-delay": "250",
  "data-aos-duration": "500"
}
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "test-description" }
const _hoisted_20 = { class: "testimonial-info" }
const _hoisted_21 = { class: "testimonial-name" }
const _hoisted_22 = { class: "testimonial-rates" }

import { computed, onMounted } from "vue";
import { useWebsiteContentStore } from "@/stores/websiteContent";

const fallbackImage = "/assets/images/backgrounds/test-img.jpeg";


export default /*@__PURE__*/_defineComponent({
  __name: 'testimonials',
  setup(__props) {

// Was fully static: three hardcoded review cards, all three attributed to
// the same fictional reviewer name ("مشعل محمد") with identical text - see
// docs/v4-migration/BROKEN-FEATURES-FOUND.md. Now backed by the real
// GET WebsiteContent/ClientOpinions endpoint (API Integrations v4 only -
// this content source did not exist in v2).
//
// NOTE on `item.image`: the backend stores exactly what the admin/CMS write
// path supplies for this field (Helper/Core/WebSite/ClientOpinionsHelper.cs
// - no server-side URL construction happens), unlike the worker photo path
// used elsewhere in this app, which is a hardcoded
// "https://office.musa3ed.com/up/{companyId}/Applicant/{file}" convention
// confirmed already live in production. There was no equivalent confirmed
// convention to reuse here, so this component renders `item.image` as-is
// (assumed to already be a complete, directly usable URL) rather than
// inventing an unverified prefix. Recorded as an open verification item in
// docs/v4-migration/DERAYAH-VUE-V4-FULL-MODERNIZATION-CERT-001.md - confirm
// against real published content once available.
const content = useWebsiteContentStore();
const desktopOpinions = computed(() => content.clientOpinions.slice(0, 3));

function ratingStars(rating: number): number[] {
  const clamped = Math.min(5, Math.max(0, rating));
  return Array.from({ length: clamped }, (_, index) => index);
}

onMounted(() => {
  if (!content.clientOpinionsLoaded) {
    content.getClientOpinions();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", {
      class: "section-title",
      "data-aos": "fade-down",
      "data-aos-duration": "500"
    }, [
      _createElementVNode("h2", { class: "main-title" }, "اراء عملائنا")
    ], -1)),
    (_unref(content).loading && _unref(content).clientOpinions.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " جارِ تحميل آراء العملاء... "))
      : (_unref(content).error && _unref(content).clientOpinions.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " تعذر تحميل آراء العملاء حاليًا. "))
        : (_unref(content).clientOpinionsLoaded && _unref(content).clientOpinions.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " لا توجد آراء عملاء منشورة حاليًا. "))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(desktopOpinions.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.clientOpinionId,
                        class: "col-lg-4"
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("img", {
                            src: item.image || fallbackImage,
                            alt: item.clientName
                          }, null, 8, _hoisted_9),
                          _createElementVNode("p", _hoisted_10, _toDisplayString(item.opinion), 1),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("h5", _hoisted_12, _toDisplayString(item.clientName), 1),
                            _createElementVNode("ul", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ratingStars(item.rating), (star) => {
                                return (_openBlock(), _createElementBlock("li", { key: star }, _cache[0] || (_cache[0] = [
                                  _createElementVNode("i", { class: "fa fa-star" }, null, -1)
                                ])))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(content).clientOpinions, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.clientOpinionId,
                        class: "swiper-slide"
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("img", {
                            src: item.image || fallbackImage,
                            alt: item.clientName
                          }, null, 8, _hoisted_18),
                          _createElementVNode("p", _hoisted_19, _toDisplayString(item.opinion), 1),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("h5", _hoisted_21, _toDisplayString(item.clientName), 1),
                            _createElementVNode("ul", _hoisted_22, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ratingStars(item.rating), (star) => {
                                return (_openBlock(), _createElementBlock("li", { key: star }, _cache[1] || (_cache[1] = [
                                  _createElementVNode("i", { class: "fa fa-star" }, null, -1)
                                ])))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "swiper-button-next testimonial-next" }, [
                    _createElementVNode("i", { class: "fas fa-chevron-left" })
                  ], -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "swiper-button-prev testimonial-prev" }, [
                    _createElementVNode("i", { class: "fas fa-chevron-right" })
                  ], -1))
                ])
              ])
            ], 64))
  ]))
}
}

})